import UserMessageItem from '../interface/UserMessageItem';

const fetchResponseDictionary: Record<string, UserMessageItem> = {
  '400': {
    statusKey: 400,
    statusText: 'Bad Request',
    userText: `It looks like the selected site isn't returning information that we are expecting. Try another site, or contact the RSS team.`,
    alertType: 'error',
    debugOnly: false,
  },
  '404': {
    statusKey: 404,
    statusText: 'Not Found',
    userText: `The requested resource cannot be found. Try another site, or contact the RSS team.`,
    alertType: 'error',
    debugOnly: false,
  },
  '408': {
    statusKey: 408,
    statusText: 'Request Timeout',
    userText: `The Cisco API timed out during the request for the device, please try again in a few minutes. If the issue persists, please contact the RSS team.`,
    alertType: 'error',
    debugOnly: false,
  },
  '429': {
    statusKey: 429,
    statusText: 'Too Many Requests',
    userText: 'Looks like too many requests have been sent, please try again in a few minutes.',
    alertType: 'error',
    debugOnly: false,
  },
  '500': {
    statusKey: 500,
    statusText: 'Internal Server Error',
    userText:
      'There was a problem completing your request, please try again in a few minutes. If the issue persists, please contact the RSS team.',
    alertType: 'error',
    debugOnly: false,
  },
  '504': {
    statusKey: 504,
    statusText: 'Gateway Timeout',
    userText: 'A device is taking too long to respond.',
    alertType: 'error',
    debugOnly: false,
  },
  userAbortedRequest: {
    statusKey: 'userAbortedRequest',
    statusText: 'DOMException',
    userText: 'The user aborted a request.',
    alertType: 'info',
    debugOnly: true,
  },
  NO_SWITCH_FOUND: {
    statusKey: 'NO_SWITCH_FOUND',
    statusText: 'There was no active switches found for this site.',
    userText: 'If you believe this is an error, please reach out to the GOALIE team.',
    alertType: 'info',
    debugOnly: false,
  }, 
  PORT_ISSUE: {
    statusKey: 'PORT_ISSUE',
    statusText: 'Switch may appear incorrect. Problem with the port(s)',
    userText: 'If you believe this is an error, please reach out to the GOALIE team.',
    alertType: 'info',
    debugOnly: false,
  },
};

export default fetchResponseDictionary;
